import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = async () => {
    const { data } = await api.get("/content");
    setContent(data);
    return data;
  };

  useEffect(() => {
    refresh().catch(() => setContent({ settings: {}, services: [], projects: [], testimonials: [] }));
  }, []);

  return <ContentContext.Provider value={{ content, refresh }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
